import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=d28b6650&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=d28b6650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28b6650",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d28b6650')) {
      api.createRecord('d28b6650', component.options)
    } else {
      api.reload('d28b6650', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=d28b6650&scoped=true&", function () {
      api.rerender('d28b6650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/VisaoGeral/components/Accordion.vue"
export default component.exports